import { Type } from 'class-transformer'
import { EnumEntity } from '..'
import { PurchaseOrder } from '@/entities/purchase'

export class SupportDocumentType extends EnumEntity {
    @Type(() => PurchaseOrder)
    purchaseOrder: PurchaseOrder;
}
